import React from 'react';
import {Button, Popconfirm, Tooltip} from 'antd';
import {Link} from 'react-router-dom';

export function UserCarsActions({ onRemoveSelected, onCheckSelected, onExport, onMoveUp, hasSelected }) {

  return (
    <div className="actions">
      <Action icon={'plus'} label={'Добавить'} to={'/user/cars/add'} type={'primary'} />
      <Action icon={'sync'} label={'Обновить'} onClick={onCheckSelected} enabled={hasSelected} />
      <Action icon={'up'} label={'Переместить в начало'} onClick={onMoveUp} enabled={hasSelected} />
      <Action icon={'save'} label={'Экпортировать в excel'} onClick={onExport} enabled={hasSelected} />
      <Action icon={'delete'} label={'Удалить'} type={'danger'} enabled={hasSelected} onClick={onRemoveSelected} />
    </div>
  );
}


function Action({ icon, label, loading = false, onClick, to, type = '', enabled = true }) {
  const button = (
    <Tooltip placement="bottom" title={label}>
      <Button icon={icon} loading={loading} onClick={onClick} type={type} disabled={!enabled} />
    </Tooltip>
  );

  return to ?  <Link to={to}>{button}</Link> : button;
}



// WEBPACK FOOTER //
// ./src/components/pages/user/user-cars-actions.js